module.exports = __webpack_public_path__ + "img/1.0b1c5937.jpg";